<div class="fx-fill fx-layout-col">
  <div class="sheet-header">
    <div class="fx-layout-row fx-justify-start fx-align-baseline">
      <div class="sheet-title fx-flex-85-percent">
        <span>{{ investment?.toString() }}</span>
      </div>
      <div class="fx-flex-48">
        <div class="btn-container">
          <button (click)="closeInvestmentSidebar()" [disableRipple]="true"
                  class="fx-layout-col fx-justify-center fx-align-center"
                  id="close-sheet-button" mat-icon-button>
            <i class="mdi mdi-close sm"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="fx-layout-row">
      <restricted-icon-button
        (onClick)="uploadInvestmentDocuments()"
        [class]="'mdi mdi-paperclip sm'"
        [id]="'upload-investment-document-button'"
        [matTooltip]="'BUTTON.ADD_DOCUMENT' | translate"
        [permissions]="[Permission.EDIT_INVESTMENT, Permission.CREATE_DOCUMENT]">
      </restricted-icon-button>
      <restricted-icon-button
        (onClick)="deleteInvestment()"
        [class]="'mdi mdi-delete sm'"
        [id]="'delete-investment-button'"
        [matTooltip]="'BUTTON.DELETE' | translate"
        [permissions]="[Permission.DELETE_INVESTMENT]">
      </restricted-icon-button>
      <restricted-icon-button
        (onClick)="duplicateInvestment()"
        [class]="'mdi mdi-content-copy sm'"
        [id]="'duplicate-investment-button'"
        [matTooltip]="'BUTTON.DUPLICATE' | translate"
        [permissions]="[Permission.CREATE_INVESTMENT]">
      </restricted-icon-button>
      <span class="fx-flex"></span>

      <div class="sheet-link">
        <span (click)="navigateToInvestmentSheet()">{{ 'BUTTON.SHOW_INVESTMENT_SHEET' | translate }}</span>
      </div>
    </div>
  </div>
  <div cdk-scrollable class="sidebar-sheet fx-flex-grow">
    <div class="page-sidebar">
      <div class="form-container">
        @if (investment) {
          <form-builder
            [formId]="formId"
            [displayHeader]="false"
            [eventsOrigin]="eventsOrigin"
            [permissionsForEdition]="permissionsForEdition">
          </form-builder>
        }
      </div>
      <div class="document-title fx-layout-row fx-justify-start fx-align-center">
        <span class="fx-flex-30-percent"> {{ 'LABEL.DOCUMENT' | translate }} </span>
        <restricted-text-button
          (onClick)="uploadInvestmentDocuments()"
          [id]="'investments-upload-document-button'"
          [permissions]="[Permission.EDIT_INVESTMENT, Permission.CREATE_DOCUMENT]"
          class="btn-upload-document">
          {{ 'BUTTON.ADD_DOCUMENT' | translate }}
        </restricted-text-button>
      </div>
      @for (document of investment?.documents; track document.id) {
        <div class="document-content">
          @if (accessManager.hasAccess(Permission.EXPORT_DOCUMENT)) {
            <a (click)="fileService.downloadFile(document.id)">
              <i class="mdi mdi-file-outline xs"></i>
              <span class="file-name-label">{{ document.name }}</span>
            </a>
          } @else {
            <span class="file-name-label">{{ document.name }}</span>
          }
          <span (click)="deleteInvestmentDocument(document)"
                [permission-lock]="[Permission.EDIT_INVESTMENT, Permission.DELETE_DOCUMENT]"
                class="delete-document-icon">
            <i class="mdi mdi-delete xs"></i>
          </span>
        </div>
      }
    </div>
  </div>
</div>
